import differenceInYears from 'date-fns/differenceInYears';
import { isValid, parseISO } from 'date-fns';
import { dateFnsFormat } from '@/helpers/dateFns';
import Profile from './profile';

export default class CertificateProfile extends Profile {
  constructor(profile = {}, url) {
    super(profile, url);

    this.address = profile?.address || null;
    this.first_name = profile?.first_name || '';
    this.last_name = profile?.last_name || '';
    this.middle_name = profile?.middle_name || '';
    this.email = profile?.email || null;
    this.email_verified_at = profile?.email_verified_at || '';
    this.phone = profile?.phone || null;
    this.caption = profile?.caption || null;
    this.birthday_at = dateFnsFormat.normalizeDate(profile?.birthday_at);
    this.snils = profile?.snils || null;

    this.options = profile.options || {}; // { class: '8' },

    this.fullName = [this.last_name, this.first_name, this.middle_name].filter(Boolean).join(' ').trim();

    this.name = (profile?.name || this.fullName).trim() || '';

    this.is_all_required_filled = profile?.is_all_required_filled ?? true;
  }

  get age() {
    const { birthday_at } = this;

    if (!birthday_at) {
      return '';
    }

    const birthdayDate = typeof birthday_at === 'string' && /^\d{4}-\d{2}-\d{2}(?: \d{2}:\d{2})?$/.test(birthday_at)
      ? parseISO(birthday_at.replace(' ', 'T'))
      : new Date(birthday_at);
    if (!isValid(birthdayDate)) return '';

    return differenceInYears(new Date(), birthdayDate);
  }
}
